let SigninForm = {
  _username: '',
  _password: '',

  error: '',

  toPayload: function() {
    return {
      _username: this._username,
      _password: this._password
    };
  },

  reset: function() {
    this.error = '';
    this._username = '';
    this._password = '';
  }
};

export default SigninForm;



// WEBPACK FOOTER //
// ./client/app/pages/signin/model/form.model.js